import { useEffect, useState } from 'react';

import { isUserAccessAllowed } from '@ce-cfbdigital/cgl-cfb-fe-foundation';

import { oktaAuth } from '../../auth';
import { logger } from '../../logger';

export const usePermissions = (roles = [], allRuleCheck = false) => {
  const [loading, setLoading] = useState(true);
  const [hasAccess, setHasAccess] = useState(false);

  const checkAccess = async () => {
    let accessAllowed = true;
    await roles.reduce(async (_, role) => {
      if (accessAllowed) {
        const isAllowed = await isUserAccessAllowed(oktaAuth, { roles: [role] });
        if (!isAllowed) {
          accessAllowed = false;
        }
      }
    }, Promise.resolve());

    return accessAllowed;
  };

  useEffect(() => {
    const fetchPermissions = async () => {
      try {
        let hasUserAccess = false;
        if (allRuleCheck) {
          hasUserAccess = await checkAccess();
        } else {
          hasUserAccess = await isUserAccessAllowed(oktaAuth, { roles });
        }

        setHasAccess(hasUserAccess);
      } catch (error) {
        logger.error(error);
      } finally {
        setLoading(false);
      }
    };

    if (roles.length) {
      fetchPermissions();
    } else {
      setLoading(false);
      setHasAccess(true);
    }
  }, [roles]);

  return { loading, hasAccess };
};

export default usePermissions;
